<template>
  <div>
    <h1>{{ $lang("第三屆澳門全民運動會網上報名表") }}</h1>
    <b-form>
      <b-form-checkbox disabled v-model="form.noChineseName">{{
        $lang("FIELD_NO_CHINESE_NAME")
      }}</b-form-checkbox>
      <template v-if="!form.noChineseName">
        <b-form-group :label="$lang('FIELD_LAST_NAME_ZH')">
          <b-form-input
            type="text"
            v-model="form.firstNameZh"
            disabled
            :placeholder="$lang('請輸入姓氏')"
          />
        </b-form-group>
        <b-form-group :label="$lang('FIELD_FIRST_NAME_ZH')">
          <b-form-input
            type="text"
            v-model="form.lastNameZh"
            disabled
            :placeholder="$lang('請輸入名字')"
          />
        </b-form-group>
      </template>
      <b-form-group :label="$lang('FIELD_LAST_NAME_PT')">
        <b-form-input
          type="text"
          v-model="form.firstNamePt"
          disabled
          :placeholder="$lang('請輸入姓氏')"
        />
      </b-form-group>
      <b-form-group :label="$lang('FIELD_FIRST_NAME_PT')">
        <b-form-input
          type="text"
          v-model="form.lastNamePt"
          disabled
          :placeholder="$lang('請輸入名字')"
        />
      </b-form-group>
      <b-form-group :label="$lang('FIELD_GENDER')">
        <b-form-radio-group name="radio-inline" v-model="form.gender" disabled>
          <b-form-radio value="M">{{ $lang("FIELD_MALE") }}</b-form-radio>
          <b-form-radio value="F">{{ $lang("FIELD_FEMALE") }}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group :label="$lang('FIELD_BORN_AT')">
        <b-input-group>
          <b-input-group-prepend>
            <i class="fa fa-calendar"></i>
          </b-input-group-prepend>
          <DatePicker
            type="date"
            disabled
            v-model="form.bornAt"
            size="large"
            @on-change="
              date => {
                form.bornAt = date;
              }
            "
            :class="errors.has('bornAt') && 'is-invalid'"
            v-validate="'required'"
            format="yyyy/MM/dd"
          ></DatePicker>
        </b-input-group>
      </b-form-group>
      <b-form-group :label="$lang('FIELD_ID_NUMBER')">
        <b-form-input
          type="text"
          v-model="form.idNumber"
          disabled
          :placeholder="$lang('請輸入名字')"
        />
        <p>
          <span
            class="text-primary"
            v-html="$lang('HELP_BLOCK_ID_NUMBER')"
          ></span>
        </p>
      </b-form-group>
      <b-form-group :label="$lang('FIELD_MOBILE')">
        <b-input-group>
          <b-input-group-prepend class="search-selete">
            <model-select
              :options="areaCodes"
              v-model="form.contact[0]"
              isDisabled
              placeholder="select item"
            ></model-select>
          </b-input-group-prepend>
          <b-form-input
            type="text"
            v-model="form.contact[1]"
            disabled
            :placeholder="$lang('FIELD_CONTACTS_PHONE')"
          />
        </b-input-group>
      </b-form-group>
      <b-form-group :label="$lang('FIELD_NOTIFY_LANGUAGE')">
        <b-form-select v-model="form.favouriteLanguage" disabled>
          <option value="zh_TW">{{ $lang("zh_TW") }}</option>
          <option value="en">{{ $lang("TEXT_LAN_EN") }}</option>
          <option value="pt_PT">{{ $lang("TEXT_LAN_PT_PT") }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group :label="$lang('FIELD_ADDRESS')">
        <b-form-textarea
          v-model="form.address"
          disabled
          placeholder="請輸入地址"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <router-link
        :to="{ name: 'family-day-2019' }"
        class="btn btn-info btn-round"
        >&nbsp;&nbsp;{{ $lang("TITLE_RETURN_INDEX") }}&nbsp;&nbsp;</router-link
      >
    </b-form>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import { ModelSelect } from "vue-search-select";
export default {
  data() {
    return {
      options: [
        {
          value: 1,
          text: "男"
        },
        {
          value: 2,
          text: "女"
        }
      ],
      form: {
        address: "",
        bornAt: "",
        contact: ["+853", ""],
        favouriteLanguage: "zh_TW",
        firstNamePt: "",
        firstNameZh: "",
        gender: "M",
        idNumber: "",
        idType: "",
        lastNamePt: "",
        lastNameZh: "",
        noChineseName: false
      }
    };
  },
  computed: {
    areaCodes() {
      return this.$store.getters["base/areaCodes"];
    }
  },
  methods: {
    getUserInfo() {
      $apis.user
        .getUserInfo()
        .then(resp => {
          this.form = resp.data;
        })
        .catch(err => {
          this.notification.error(this.$lang(err.message));
        });
    }
  },
  components: {
    ModelSelect
  },
  created() {
    this.getUserInfo();
  }
};
</script>
